import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';

export const AdminBrandsLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('brands.title'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'brands',
                label: t('brands.title'),
                url: ROUTES.admin.brands.list,
                isActive: path === ROUTES.admin.brands.list,
              },
              {
                key: 'prompts',
                label: t('prompts.title', { count: 2 }),
                url: ROUTES.admin.brands.prompts.list,
                isActive: path === ROUTES.admin.brands.prompts.list,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
